// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetNewsApiParameter, getNewsData as getNewsDataApi } from "@bg/App/Services/NewsService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { PageProps } from "@insite/mobius/Page";

export type NewsResult = {
    pages: PageProps[];
    pagination: any;
};

type HandlerType = ApiHandler<GetNewsApiParameter, any>;

export const DispatchBeginLoadNewsData: HandlerType = props => {
    props.dispatch({
        type: "CustomNews/BeginLoadData" as any,
    });
};

export const RequestDataFromNewsApi: HandlerType = async props => {
    props.apiResult = await getNewsDataApi(props.apiParameter);
};

export const DispatchCompletedLoadNewsData: HandlerType = props => {
    props.dispatch({
        type: "CustomNews/CompletedLoadingData" as any,
        result: (props.apiResult as any).result as any,
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadNewsData,
    RequestDataFromNewsApi,
    DispatchCompletedLoadNewsData,
];

const loadNewsItems = createHandlerChainRunner(chain, "loadNewsItems");
export default loadNewsItems;
